import * as _ from 'underscore';
import * as $ from 'jquery';

import { apiCall } from '../../ts/AqlUtility';
import { AppActions } from '../../../../pdc-platform/src/ts/actions/AppActions';

import { HelpPopupBox, IHelpPopupOptions } from './HelpPopupBox';
import { DialogActions } from '../../../../pdc-platform/src/ts/actions/DialogActions';

const Hogan = require('hogan.js');
//const Mustache = require('mustache-for-chromeapps');

export class HelpTools {
    private expressionSyntaxDoc = null;

    public getExpressionSyntax(actions: AppActions) {
        const def = $.Deferred();

        if (this.expressionSyntaxDoc == null) {
            const helperDef = apiCall(actions, 'frontendHelper_GetExpressionsHelp', {});

            helperDef
                .then((result) => {
                    this.expressionSyntaxDoc = result.result;
                    def.resolve(result.result);
                })
                .fail(() => {
                    console.warn("Can't load Expression syntax definition");
                    def.reject();
                });
        } else {
            def.resolve(this.expressionSyntaxDoc);
        }

        return def;
    }

    public getExpressionsTOC(jsonDoc) {
        const categories = {
            categories: _.chain(jsonDoc)
                .pluck('category')
                .uniq()
                .sortBy()
                .map((el) => {
                    return {
                        category: el,
                        href: el.replace(' ', '_')
                    };
                })
                .value()
        };

        const template = Hogan.compile(
            "<h2>Table of Content</h2>{{#categories}}<a href='#{{href}}' class='text-capitalize'>{{category}}</a><br/>{{/categories}}"
        );
        const TOC = template.render(categories);
        //const TOC = Mustache.to_html(
        //     "<h2>Table of Content</h2>{{#categories}}<a href='#{{href}}' class='text-capitalize'>{{category}}</a><br/>{{/categories}}",
        //     categories
        // );
        return TOC;
    }

    public getExpressionsHelp(jsonDoc) {
        const byCategory = _.groupBy(_.sortBy(jsonDoc, 'category'), 'category');

        let template = '';
        _.each(_.keys(byCategory), (key) => {
            template += "<h2><a id='" + key.replace(' ', '_') + "' class='text-capitalize'>" + key + '</a></h2>';
            template += '{{#' + key + '}}';
            template += '<h3>{{ caption }}</h3>';
            template += '<p><code>{{ syntax }}</code></p>';
            template += '<p>Return type: <i>{{ type }}</i></p>';
            template += '<p>{{ description }}</p>';
            template += '{{/' + key + '}}';
        });

        return Hogan.compile(template).render(byCategory);
        //return Mustache.to_html(template, byCategory);
    }

    public showHelpDocument(
        actions: DialogActions,
        title: string,
        TOC: string,
        Document: string,
        e?: any,
        showArrow?: boolean
    ) {
        var top;
        var left;

        if (e) {
            var offset = $(e.target).offset();
            top = offset.top;
            left = offset.left;
        }

        actions.createPopup<IHelpPopupOptions>('custom', {
            top: top,
            left: left,
            title: title,
            TOC: TOC,
            Document: Document,
            component: HelpPopupBox,
            popupPriority: 0,
            showArrow: showArrow
        });
    }
}
